export function readDraft(raw, now = Date.now()) {
  try {
    const draft = JSON.parse(raw);
    if (!draft || typeof draft.savedAt !== 'number' || now < draft.savedAt || now - draft.savedAt > 86400000 || !draft.values || typeof draft.values !== 'object' || Array.isArray(draft.values)) return {};
    return Object.fromEntries(Object.entries(draft.values).filter(([key, value]) => /^[a-z_]+$/.test(key) && typeof value === 'string'));
  } catch { return {}; }
}

export function mergeEnquiry(saved, params) {
  const part = params.get('part');
  const category = params.get('product');
  const changed = (part && saved.part_number && part !== saved.part_number) || (category && saved.category && category !== saved.category);
  const values = changed ? {} : { ...saved };
  if (part) values.part_number = part.slice(0, 500);
  if (category) values.category = category.slice(0, 500);
  return values;
}

function initQuote() {
  const form = document.getElementById('AXPAQuote');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const key = 'axpa-quote-draft-v1';
  const config = form.closest('[data-quote-config]');
  const fields = Array.from(form.elements).filter(field => /^contact\[[a-z_]+\]$/.test(field.name) && field.type !== 'hidden');
  const fieldKey = field => field.name.slice(8, -1);
  const status = form.querySelector('[data-quote-status]');
  const submit = form.querySelector('[type="submit"]');
  let sent = false;
  const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
  if (form.querySelector('[data-quote-success]')) {
    clear();
    const success = form.querySelector('[data-quote-success]');
    success?.focus();
    return;
  }
  let saved = {};
  try { saved = readDraft(sessionStorage.getItem(key)); } catch {}
  const values = mergeEnquiry(saved, new URLSearchParams(location.search));
  fields.forEach(field => {
    const value = values[fieldKey(field)];
    if (typeof value === 'string' && !field.value) field.value = value;
  });
  const extra = form.querySelector('[data-extra-fields]');
  if (extra && Array.from(extra.querySelectorAll('input')).some(field => field.value)) extra.open = true;
  const persist = () => {
    const values = Object.fromEntries(fields.map(field => [fieldKey(field), field.value]));
    try { sessionStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), values })); } catch {}
  };
  const messageFor = field => {
    if (field.required && !field.value.trim()) return config.dataset.required;
    if (field.validity.typeMismatch) return field.type === 'email' ? config.dataset.emailError : config.dataset.urlError;
    if (field.validity.rangeUnderflow || field.validity.stepMismatch || field.validity.badInput) return config.dataset.quantityError;
    return field.validationMessage;
  };
  const showError = field => {
    if (field.required) field.setCustomValidity(field.value.trim() ? '' : config.dataset.required);
    const error = document.getElementById(field.id + '-error');
    const message = messageFor(field);
    field.setAttribute('aria-invalid', String(Boolean(message)));
    if (error) error.textContent = message;
  };
  form.addEventListener('input', event => {
    const field = event.target;
    if (!fields.includes(field)) return;
    if (field.required) field.setCustomValidity(field.value.trim() ? '' : config.dataset.required);
    if (field.getAttribute('aria-invalid') === 'true') showError(field);
    persist();
  });
  form.addEventListener('change', persist);
  form.addEventListener('invalid', event => {
    showError(event.target);
    const detail = event.target.closest('details');
    if (detail) detail.open = true;
    status.textContent = config.dataset.checkFields;
    persist();
  }, true);
  form.addEventListener('submit', event => {
    fields.filter(field => field.required).forEach(field => field.setCustomValidity(field.value.trim() ? '' : config.dataset.required));
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }
    if (sent) { event.preventDefault(); return; }
    sent = true;
    persist();
    submit.disabled = true;
    submit.textContent = config.dataset.sending;
    form.setAttribute('aria-busy', 'true');
    status.textContent = config.dataset.sendingNote;
  });
  form.querySelector('[data-clear-draft]')?.addEventListener('click', () => {
    clear();
    fields.forEach(field => {
      field.value = field.tagName === 'SELECT' ? field.options[0].value : '';
      field.setCustomValidity('');
      field.removeAttribute('aria-invalid');
      const error = document.getElementById(field.id + '-error');
      if (error) error.textContent = '';
    });
    status.textContent = config.dataset.cleared;
    fields[0]?.focus();
  });
  window.addEventListener('pageshow', () => {
    sent = false;
    submit.disabled = false;
    submit.textContent = config.dataset.submitLabel;
    form.removeAttribute('aria-busy');
    if (status.textContent === config.dataset.sendingNote) status.textContent = config.dataset.retryNote;
  });
}

if (typeof document !== 'undefined') {
  initQuote();
  document.addEventListener('shopify:section:load', initQuote);
}

